import { render, staticRenderFns } from "./video.vue?vue&type=template&id=614bee8e&scoped=true&"
import script from "./video.vue?vue&type=script&lang=js&"
export * from "./video.vue?vue&type=script&lang=js&"
import style0 from "./video.vue?vue&type=style&index=0&id=614bee8e&prod&lang=less&scoped=true&"
import style1 from "./video.vue?vue&type=style&index=1&id=614bee8e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614bee8e",
  null
  
)

export default component.exports